import { FunctionComponent } from 'react';
import { CalendarPlusLightIcon } from '../../../../../../Icons';
import ButtonLink from '../../../../../../ButtonLink';
import styles from './styles.module.scss';

type AddToCalendarButtonProps = {
    bookingId: string;
};

export const AddToCalendarButton: FunctionComponent<AddToCalendarButtonProps> = ({ bookingId }) => {
    return (
        <ButtonLink
            href={`${process.env.NEXT_PUBLIC_CADEMY_API_URL}/bookings/${bookingId}/ical`}
            target="_blank"
            rel="noopener noreferrer"
            preset="default"
            className={styles.button}
        >
            <CalendarPlusLightIcon />
            Add to Calendar
        </ButtonLink>
    );
};
